import { z } from "zod";
export const slackConnectionInput = z.object({
  id: z.string().optional(),
  name: z.string().trim().min(1).optional(),
  webhook: z.string().trim().default(""),
  channel: z.string().trim().min(1),
  isDefault: z.boolean().optional(),
});
export const slackTestResult = z.object({
  status: z.enum(["sent", "failed", "pending", "unknown"]),
  error: z.string().nullable().optional(),
});
